/**
 *
 * CustomFormField
 *
 */
import React from 'react';
import { CustomFormFieldProps } from 'app/components/CustomForm/CustomFormFields';
import { FormRichTextField } from 'app/components/Forms/FormRichTextField';

export function CustomFormRichText({
  formField,
  readonly,
  disabled,
  ...props
}: CustomFormFieldProps) {
  return (
    <FormRichTextField
      {...props}
      disabled={readonly || disabled}
      label={formField.Label}
      key={formField.Id}
      info={formField.Description ?? undefined}
      fullWidth
    />
  );
}
